module.exports = __webpack_public_path__ + "img/mz.5c6228b0.png";